import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { fakeTableList, schemaKeiYaKuSya } from "./parts";
import { httpAPI_ACC006 } from "./api/request";

/**
 * SCRC010002 パスワード変更申請
 * @returns JSX.Element
 */
const SCRC010002 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  // ダイアログ開閉状態（合計）
  const [isOpenSaveDialog, setIsOpenSaveDialog] = useState<boolean>(false);

  const handleSubmit = async (data: any) => {
    try {
      const res = await httpAPI_ACC006(data);
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setIsOpenSaveDialog(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC010002" data-testid="SCRC010002PageForTest">
      {/* TkInfoManualを表示 */}
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC010002_01}</TkInfoManual>
      <Box>
        <TkFakeTable
          list={fakeTableList}
          ruleSchema={schemaKeiYaKuSya}
          onCheckAndSubmit={(e) => handleSubmit(e)}
          submitButtonGroup={[
            {
              submitButtonText: "パスワード発行リンク送信",
              submitButtonDisabled: false,
            },
          ]}
        />
      </Box>

      <TkMessageDialog
        open={isOpenSaveDialog}
        onOky={() => setIsOpenSaveDialog(false)}
        title="確認"
        contextText="登録されているメールアドレスにパスワード変更のためのメールを送付しましたので、メールを確認してください"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC010002;
